import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";
import { BRAND } from "../data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("verra_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-lg border border-verra-blue/15 bg-white px-4 py-3 text-sm text-verra-blue outline-none focus:border-verra-green transition-colors";

  return (
    <div className="min-h-screen bg-verra-blue flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-block bg-white rounded-xl px-5 py-3">
            <img src={BRAND.logo} alt="Verraleaf" className="h-8 w-auto" />
          </span>
          <p className="text-verra-light text-xs uppercase tracking-[0.2em] mt-4">Admin Portal</p>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="flex items-center gap-2 mb-6 text-verra-blue">
            <Lock className="w-5 h-5 text-verra-green" />
            <h1 className="font-display text-2xl">Sign in</h1>
          </div>
          {error && <p data-testid="login-error" className="mb-4 text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</p>}
          <label className="block text-xs font-semibold text-verra-blue/60 mb-1">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={`${field} mb-4`} placeholder="admin@verraleaf.com" />
          <label className="block text-xs font-semibold text-verra-blue/60 mb-1">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={`${field} mb-6`} placeholder="••••••••" />
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-verra-blue text-white font-semibold py-3.5 hover:bg-verra-green transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"} <ArrowRight className="w-4 h-4" />
          </button>
        </form>
        <p className="text-center text-white/40 text-xs mt-6">{BRAND.parent} · Authorized access only</p>
      </div>
    </div>
  );
}
